import { Component, OnInit, ViewChild, Injector, signal, computed, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { GetRenewalDetailService } from "../../adapters/getRenewalDetail.service";
import { GetMaskingService } from '../../adapters/getMasking.service';
import { PaymentDetailComponent } from "../payment-detail/payment-detail.component";
import { SendLineMessageService } from "src/app/adapters/sendLineMessage.service";
import { UpdateRenewDetailService } from "../../adapters/updateRenewDetail.service";
import { environment } from "../../../environments/environment";
import { NgForm } from "@angular/forms";
import { GetAllLocationService } from "src/app/adapters/getAllLocation.service";
import { GetCompanyUCIDService } from "src/app/adapters/getCompanyUCID.service";
import { CallTss } from "src/app/adapters/callTss.service";
import { formatDate } from "@angular/common";
import { CalculateInstallment } from "../../adapters/calculateInstallment.service";
import { UpdateRenewLetterInstallment } from "../../adapters/updateRenewLetterInstallment.service";
import { default as theme } from "../renewal-theme.json";
import { GetMotorPaymentSummary } from "../../adapters/getMotorPaymentSummary.service";
import {
  DaterangepickerDirective,
  LocaleConfig,
} from "ngx-daterangepicker-material";
import { BaseComponents } from "../../base.component";
import moment from "moment";
import { ConvertTimestamp } from "../../adapters/convertTimestamp.service";
import * as uuid from "uuid";
import liff from "@line/liff";
import { GetLineTokenService } from "src/app/adapters/getLineToken.service";
import { ModalService } from "src/app/shared/service/modal/modal.service";
import { LineModalTemplateService } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.service";
import { LineModalTemplateComponent } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.component";
import { ReferenceService } from "src/app/services/reference.service";

moment.locale("th");

declare var window: any;
interface Installment {
    date: any;
    value: any
  }
@Component({
  selector: "app-motor-step",
  templateUrl: "./motor-step.component.html",
  styleUrls: ["./motor-step.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MotorStepComponent extends BaseComponents implements OnInit {
  @ViewChild(PaymentDetailComponent) paymentDetail;
  @ViewChild("renewForm") renewForm: NgForm;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  day: any;
  month: any;
  year: any;
  months: any = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];

  liff_id: string;
  profile: any;
  rm_channelId: string;
  product_type: number;

  expiredate: any;

  // line_id: string;

  insuredetail_data: any;
  insuredetail_data_temp: any;
  f09Status: number;
  dataucid: string;
  letterucid: string;
  electronic_channel: any;
  comcode: string;

  url_default: string;

  //form_first
  total_amount = signal<number>(0.0);
  additional_option = signal<boolean[]>([]);
  additional_check_all = signal<boolean>(false);

  // form_second
  editData = signal<boolean>(false);
  editCarNo = signal<boolean>(false);
  carNo: any;
  province: any;
  editProvince: any;

  // form_third
  addClaim = signal<boolean>(false);
  addDecoration = signal<boolean>(false);
  editClaim = signal<boolean>(false);
  editDecoration = signal<boolean>(false);
  decorationdetail: any;
  decorationvalue: any;
  claimdetail: string = "";
  claimvalue: string = "";
  claimdetailEdit: string = "";
  claimvalueEdit: string = "";
  decorationIndex: any;
  claimIndex: any;
  claimValueClass = signal<string>("");
  claimValueClassEdit = signal<string>("");

  // form_fourth
  checkBoxFullPay = signal<boolean>(true);
  checkBokInstallment = signal<boolean>(false);
  dataLoadInstallment: any;
  installmentData = signal<Installment[]>([]);
  installmentStatus = signal<boolean>(false);

  // form_fifth
  companyId: any;
  addrValue1: any;
  addrValue2: any;
  addrValue3: any;
  addrValue4: any;
  phoneValue: any;
  editAddr = signal<boolean>(false);
  editTel = signal<boolean>(false);

  form_first = signal<boolean>(true);
  form_second = signal<boolean>(false);
  form_third = signal<boolean>(false);
  form_fourth = signal<boolean>(false);
  form_fifth = signal<boolean>(false);

  loader = signal<boolean>(true);
  hiddenHTML = signal<boolean>(true)
  otherProductImage: object;

  style: any = {};

  limitdate: any = moment();

  subDistrict: any;
  district: any;
  province2: any;
  keyword = "text";
  referenceUUID: string | null = null;
  subChannel: number | null = null;
  isCompulsory = signal<boolean>(false);

  public datepickerSelected = { startDate: null, endDate: null };
  public locale: LocaleConfig = {
    applyLabel: "ยืนยัน",
    cancelLabel: "ยกเลิก",
    customRangeLabel: " - ",
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    format: "DD/MM/YYYY",
    firstDay: 1,
  };
  logger_text = `motor-step ${uuid.v4()} =>`;
  // access_token_line : string = ""
  liff_channel_id: string = "";
  channel_line_id: string = "";
  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private router: Router,
    private getRenewalDetailService: GetRenewalDetailService,
    private getMaskingService: GetMaskingService,
    private sendLineMessageService: SendLineMessageService,
    private updateRenewDetailService: UpdateRenewDetailService,
    private getAllLocationService: GetAllLocationService,
    private getCompanyUCIDService: GetCompanyUCIDService,
    private callTss: CallTss,
    private calculateInstallment: CalculateInstallment,
    private updateRenewLetterInstallment: UpdateRenewLetterInstallment,
    private getMotorPaymentSummary: GetMotorPaymentSummary,
    private convertTimestamp: ConvertTimestamp,
    private getLineTokenService: GetLineTokenService,
    private modalService: ModalService,
    private lineModalService: LineModalTemplateService,
    private referenceService: ReferenceService
  ) {
    super(injectorObj);
    this.insuredetail_data = {
      additionalProduct: [],
      address: "",
      carBrand: "",
      carNo: "",
      carProvince: null,
      carUsage: null,
      carYear: null,
      claim: [],
      decoration: [],
      installment: [],
      insuredName: "",
      lastClaimDate: "",
      name: "",
      oldExpireDate: "",
      oldInsureModel: "",
      oldInsureNo: "",
      oldInsureType: null,
      phoneNo: "",
      nameOfferInsureBrand: "",
      offerInsureAmount: 0,
      offerInsureFund: 0,
      offerInsureClaim: "",
      protection1: 0,
      protection2: 0,
      protection3: 0,
      protection4: 0,
      protection5: 0,
      protection6: 0,
      protection7: 0,
      protection8: 0,
      protection9: 0,
      protection10: 0,
      protection11: 0,
      protection12: 0,
      refNo: "",
      refNo2: "", //use in first form
      totalamount: 0,
      insuranceType: "",
      product_type: null,
      instTerm: 0,
      instFirstDate: "",
      logoOfferInsureBrand: "",
      fixOffer: "",
      otherProductImage: "",
      item2936_16211: "",
    };
    // Create temp
    this.insuredetail_data_temp = {
      additionalProduct: [],
      address: "",
      carBrand: "",
      carNo: "",
      carProvince: null,
      carUsage: null,
      carYear: null,
      claim: [],
      decoration: [],
      installment: [],
      insuredName: "",
      lastClaimDate: "",
      name: "",
      oldExpireDate: "",
      oldInsureModel: "",
      oldInsureNo: "",
      oldInsureType: null,
      phoneNo: "",
      nameOfferInsureBrand: "",
      offerInsureAmount: 0,
      offerInsureFund: 0,
      offerInsureClaim: "",
      protection1: 0,
      protection2: 0,
      protection3: 0,
      protection4: 0,
      protection5: 0,
      protection6: 0,
      protection7: 0,
      protection8: 0,
      protection9: 0,
      protection10: 0,
      protection11: 0,
      protection12: 0,
      refNo: "",
      refNo2: "", //use in first form
      totalamount: 0,
      insuranceType: "",
      product_type: null,
      instTerm: 0,
      instFirstDate: "",
      logoOfferInsureBrand: "",
      fixOffer: "",
      otherProductImage: "",
      item2936_16211: "",
    };

    this.dataLoadInstallment = {
      response_code: "",
      data: [],
    };
    this.installmentData.set([
      {
        date: 0,
        value: 0,
      },
    ]);
  }

  async ngOnInit() {
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.logger_text = `motor-step ${uuid.v4()} referenceUUID:[${this.referenceUUID}] =>`
    this.logger.info(`${this.logger_text} start`);
    this.route.queryParams.subscribe((params) => {
      this.dataucid = params["dataucid"];
      this.letterucid = params["letterucid"];
      this.liff_id = params["appRef"];
      this.rm_channelId = params["rm_channelId"];
      this.electronic_channel = params["electronic_channel"];
      this.comcode = params["comcode"];
      this.style = theme[this.comcode];
      this.product_type = params["product_type"];
      this.liff_channel_id = params["liff_channel_id"];
      this.channel_line_id = params["channel_line_id"];
      this.logger.info([this.logger_text, "params motor :", params]);
      this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null;

      // let _self = this
      // $(document).ready(function () {
      //   var $dateTime = $('.date-time')
      //   var datepickerFrom = UIkit.datepicker($dateTime, { format: 'DD/MM/YYYY' });
      // });
    });

    try {
      // this.access_token_line = await this.getLineTokenService.exec(liff,this.liff_id, this.logger);
      this.getData(this.dataucid, this.letterucid);
      // if(environment.production){
      //   await liff.init({ liffId: this.liff_id})
      //   if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //     this.logger.info([this.logger_text,'login liff callback path:', window.location.href]);
      //     liff.login({ redirectUri: window.location.href })
      //   }else{
      //     this.access_token_line = await liff.getAccessToken();
      //     this.logger.debug([this.logger_text,'access_token_line:', this.access_token_line]);
      //     this.getData(this.dataucid, this.letterucid);
      //     // const profile = await liff.getProfile();
      //     // this.line_id = profile.userId;
      //   }
      // }else{
      //   this.router.navigate(['/renewal/page-error']);
      //   // this.line_id = 'Ub012cbba3e3e801afa23f67565535b16';
      // }
    } catch (error) {
      // this.line_id = 'Ub012cbba3e3e801afa23f67565535b16';
      this.handleError(error,`ngOnInit getData`);
    }
    // this.logger.info(['user_id: ' + this.line_id]);

    if (environment.log_level == "debug") {
      window.vConsole = new window.VConsole();
    }
  }

  getData(dataucid: any, letterucid: any) {
    this.loader.set(true);
    const funcName = `getData`;
    this.logger.info(`${this.logger_text} ${funcName} getRenewalDetailService start`)
    this.getRenewalDetailService
      .exec({ dataucid: dataucid, letterucid: letterucid })
      .then((res: any) => {
        this.logger.debug(res);        
        this.loader.set(false);

        if (res.response_code === "40000") {
          this.hiddenHTML.set(false);
          this.logger.info(`${this.logger_text} ${funcName} getRenewalDetailService response success`)
          this.insuredetail_data = res.data.obj;
          this.isCompulsory.set(this.insuredetail_data.isCompulsory);
          this.insuredetail_data_temp = JSON.parse(
            JSON.stringify(res.data.obj)
          );
          this.logger.debug("getData", this.insuredetail_data);
          this.logger.info(`${this.logger_text} ${funcName} Motor-step refNo2:${this.insuredetail_data.refNo2}`)
          this.logger.info(`${this.logger_text} ${funcName} Motor-step refNo2:${this.insuredetail_data.refNo2} data ucid:${this.dataucid}`)
          this.logger.info(`${this.logger_text} ${funcName} Motor-step refNo2:${this.insuredetail_data.refNo2} letter ucid:${this.letterucid}`)

          if (this.insuredetail_data.otherProductImage != "") {
            this.logger.info(`${this.logger_text} ${funcName} Motor-step refNo2:${this.insuredetail_data.refNo2} otherProductImage have data`)

            this.logger.debug(this.insuredetail_data.otherProductImage);
            let img_list = JSON.parse(this.insuredetail_data.otherProductImage);
            this.logger.debug(img_list);
            this.otherProductImage = img_list;
          }
          this.logger.debug("Img list", this.otherProductImage);
          this.getCompanyUCIDService.exec({}).then((res: any) => {
            this.companyId = res.data ? res.data._1 : "";
          });

          this.expiredate = new Date(this.insuredetail_data.oldExpireDate);
          let month_expiredate = this.expiredate.getUTCMonth() + 1;
          let day_expiredate = this.expiredate.getDate();
          let year_expiredate = this.expiredate.getUTCFullYear();
          this.day = day_expiredate;
          this.month = this.months[parseInt(month_expiredate) - 1];
          this.year = parseInt(year_expiredate) + 543;
          this.expiredate =
            this.day + " " + this.month.toString() + " " + this.year.toString();
          let withoutSpace = this.insuredetail_data.carNo
            ? this.insuredetail_data.carNo.replace(/ /g, "")
            : [];
          if (withoutSpace.length == 0) {
            this.insuredetail_data.carNo = "";
          }

          // this.onSetLimitDate();
          this.addCheckAdditionalOptionToArray();
          this.setAdditional_check_all();
          this.calculateTotalPrice();
        } else {
          this.logger.info(`${this.logger_text} ${funcName} getRenewalDetailService response data not found`)
          this.modalService
            .open(
              LineModalTemplateComponent,
              this.lineModalService.setModalConfig(
                "alert",
                "ไม่สามารถทำรายการได้",
                ["ขออภัย ไม่พบรายการของท่าน"]
              )
            )
            .onResult()
            .subscribe({
              next: (result2) => {
                this.logger.info(
                  `${this.logger_text} getRenewalDetailService popup success`
                );
              },
              error: (err2) => {
                this.logger.info(
                  `${this.logger_text} getRenewalDetailService popup message:${err2}`
                );
              },
              complete: () => {
                this.logger.info(
                  `${this.logger_text} getRenewalDetailService popup complete`
                );
              },
            });
        }
      })
      .catch((error) => {
        this.loader.set(false);
        this.handleError(error,`getData getRenewalDetailService`)
      });
  }

  onBackToFirst() {
    this.form_second.set(false);
    this.form_first.set(true);
    this.form_third.set(false);
    this.form_fourth.set(false);
    this.form_fifth.set(false);
  }

  onNextToSecond() {
    this.form_second.set(true);
    this.form_first.set(false);
    this.form_third.set(false);
    this.form_fourth.set(false);
    this.form_fifth.set(false);
  }

  onNextToThird() {
    this.form_first.set(false);
    this.form_second.set(false);
    this.form_third.set(true);
    this.form_fourth.set(false);
    this.form_fifth.set(false);
  }

  onNextToFourth() {
    this.form_first.set(false);
    this.form_second.set(false);
    this.form_third.set(false);
    this.form_fourth.set(true);
    this.form_fifth.set(false);
    this.onLoadInstallment();
  }

  onNextToFifth() {
    this.form_first.set(false);
    this.form_second.set(false);
    this.form_third.set(false);
    this.form_fourth.set(false);
    this.form_fifth.set(true);
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // form_first

  onChangeCarNo(e) {
    this.carNo = e;
  }

  onSelectProvince(e) {
    this.editProvince = e.target.value;
  }

  onEditData() {
    this.editData.set(true);
    this.editProvince = this.insuredetail_data.carProvince;
  }

  onEditCarNo() {
    this.editCarNo.set(true);
    this.carNo = this.insuredetail_data.carNo;
  }

  onSaveData() {
    this.editData.set(false);
    this.insuredetail_data.carProvince = this.editProvince;
  }

  onSaveCarNo() {
    this.editCarNo.set(false);
    let withoutSpace = this.carNo.replace(/ /g, "");
    if (withoutSpace.length == 0) {
      this.insuredetail_data.carNo = "";
    } else {
      this.insuredetail_data.carNo = this.carNo;
    }
  }

  onCancelEditData() {
    this.editData.set(false);
    this.editProvince = "";
  }

  onCancelEditCarNo() {
    this.editCarNo.set(false);
    this.carNo = "";
  }

  onShowProvinceName(e) {
    for (let i = 0; i < this.insuredetail_data.province.length; i++) {
      if (e == this.insuredetail_data.province[i].value) {
        this.province = this.insuredetail_data.province[i].detail;
        return this.province;
      }
    }
  }

  checkDisabled = computed(() => {
  const hasCarNo = !!this.insuredetail_data.carNo;
  const hasProvince = !!this.insuredetail_data.carProvince;

  return hasCarNo && !hasProvince;
  });

  // form_second

  onEditCarUsage(e) {
    this.insuredetail_data.carUsage = e.target.value;
  }

  onAddClaim() {
    this.addClaim.set(true);
  }

  onInputClaimDetail(e) {
    this.claimdetail = e.target.value;
  }

  onInputClaimDetailEdit(e) {
    this.claimdetailEdit = e.target.value;
  }

  isCustomDate(date) {
    let dayjsDate = moment(date.toISOString());
    return dayjsDate.weekday() === 0 || dayjsDate.weekday() === 6
      ? "uk-background-muted"
      : false;
  }

  datesUpdated(event) {
    this.logger.debug(event);
  }

  openDatepicker() {
    this.pickerDirective.open();
  }

  checkDateFormat(e) {
    if ((e.target.value.match(/\//g) || []).length == 2) {
      let date_split = e.target.value.split("/");
      // check format and max date
      if (date_split[2] && date_split[2].length > 3) {
        let day =
          date_split[0].length == 1 ? "0" + date_split[0] : date_split[0];
        let month =
          date_split[1].length == 1 ? "0" + date_split[1] : date_split[1];
        let year = date_split[2];
        let date = year + "-" + month + "-" + day;
        let isAfter = moment().isAfter(date);
        if (isAfter) {
          if (this.editClaim()) {
            this.claimValueClassEdit.set("uk-form-success");
          } else {
            this.claimValueClass.set("uk-form-success");
          }
          return;
        }
      }
    }
    if (this.editClaim()) {
      this.claimValueClassEdit.set("uk-form-danger");
    } else {
      this.claimValueClass.set("uk-form-danger");
    }
  }

  onInputClaimValue(e) {
    if (e.target) {
      let date_split = e.target.value.split("/");
      let day = date_split[0].length == 1 ? "0" + date_split[0] : date_split[0];
      let month =
        date_split[1].length == 1 ? "0" + date_split[1] : date_split[1];
      let year = date_split[2];

      this.claimvalue = day + "/" + month + "/" + year;
    } else if (e.startDate) {
      this.claimvalue = e.startDate.format("DD/MM/YYYY");
    }
  }

  onInputClaimValueEdit(e) {
    if (e.target) {
      let date_split = e.target.value.split("/");
      let day = date_split[0].length == 1 ? "0" + date_split[0] : date_split[0];
      let month =
        date_split[1].length == 1 ? "0" + date_split[1] : date_split[1];
      let year = date_split[2];

      this.claimvalueEdit = day + "/" + month + "/" + year;
    } else if (e.startDate) {
      this.claimvalueEdit = e.startDate.format("DD/MM/YYYY");
    }
  }

  onInputDecorationDetail(e) {
    this.decorationdetail = e.target.value;
  }

  onInputDecorationValue(e) {
    this.decorationvalue = e.target.value.replace(/[^0-9]*/g, "");
  }

  // onAddDecoration() {
  //   this.addDecoration = true;
  // }

  onEditClaim(e) {
    this.editClaim.set(true);
    this.claimIndex = e;
    this.claimdetailEdit = this.insuredetail_data.claim[e].detail;
    this.claimvalueEdit = this.insuredetail_data.claim[e].value;
    this.datepickerSelected = {
      startDate: moment(this.claimvalueEdit, "DD/MM/YYYY"),
      endDate: moment(this.claimvalueEdit, "DD/MM/YYYY"),
    };
  }

  onDeleteClaim(e) {
    this.insuredetail_data.claim.splice(e, 1);
  }

  onSaveClaim(e) {
    if (e == 9999) {
      this.addClaim.set(false);
      this.insuredetail_data.claim.push({
        detail: this.claimdetail,
        value: this.claimvalue,
        status: "new",
      });
      this.claimdetail = "";
      this.claimvalue = "";
      this.claimValueClass.set("");
      this.datepickerSelected = { startDate: null, endDate: null };
    } else {
      this.editClaim.set(false);
      this.insuredetail_data.claim[e].detail = this.claimdetailEdit;
      this.insuredetail_data.claim[e].value = this.claimvalueEdit;
      this.claimdetailEdit = "";
      this.claimvalueEdit = "";
      this.datepickerSelected = { startDate: null, endDate: null };
    }
  }

  onCancelAddClaim() {
    this.addClaim.set(false);
    this.editClaim.set(false);
    this.claimdetail = "";
    this.claimvalue = "";
    this.claimValueClassEdit.set("");
    this.claimValueClass.set("");
    this.datepickerSelected = { startDate: null, endDate: null };
  }

  onEditDecoration() {
    this.editDecoration.set(true);
    this.decorationIndex = 0;
    this.decorationdetail = this.insuredetail_data.decoration[0];
  }

  onSaveDecoration() {
    this.editDecoration.set(false);
    this.insuredetail_data.decoration[0] = this.decorationdetail;
    this.decorationdetail = "";
  }

  onDeleteDecoration() {
    this.insuredetail_data.decoration[0] = "";
  }

  onCancelAddDecoration() {
    this.addDecoration.set(false);
    this.editDecoration.set(false);
    this.decorationdetail = "";
    this.decorationvalue = "";
  }

  // form_third
  model: any = {
    address: {
      current: {
        subDistrict: "",
        subDistrictText: "",
        district: "",
        districtText: "",
        province: "",
        provinceText: "",
        postCode: "",
        postCodeText: "",
      },
    },
  };
  results: any = {};
  timeout: any = {};
  search: string = "";
  isLoading: any = {};
  regZipCode = /^[0-9]{5}\d*$/;

  public addClass(f: NgForm, field: string, type?: string, valueActive = "") {
    let iClass = [];
    if (f.form.controls[field] && type !== "msg") {
      if (
        f.form.controls[field].invalid &&
        (f.form.controls[field].dirty ||
          f.form.controls[field].touched ||
          f.submitted)
      ) {
        iClass.push("uk-form-danger");
      } else if (
        f.form.controls[field].valid &&
        (f.form.controls[field].dirty ||
          f.form.controls[field].touched ||
          f.submitted)
      ) {
        if (valueActive === "") {
          iClass.push("uk-form-success");
        } else if (f.form.controls[field].value == valueActive) {
          iClass.push("uk-form-success");
        }
      }
    } else if (f.form.controls[field] && type == "msg") {
      if (
        f.form.controls[field].invalid &&
        (f.form.controls[field].dirty ||
          f.form.controls[field].touched ||
          f.submitted)
      ) {
        iClass.push("uk-animation-fade");
      } else if (
        f.form.controls[field].valid &&
        (f.form.controls[field].dirty ||
          f.form.controls[field].touched ||
          f.submitted)
      ) {
        iClass.push("uk-animation-reverse");
      }
    }
    return iClass;
  }

  onChangeSearch2(search: string, type: string, mode: string = "current") {
    if (this.timeout[type]) {
      clearTimeout(this.timeout[type]);
    }
    this.timeout[type] = setTimeout(() => {
      this.searchData(search, type, mode);
    }, 1);
  }

  searchData(search: string, type: string, mode: string = "current") {
    let body = {
      subDistrict: type == "subDistrict" ? search : "",
      district: type == "district" ? search : "",
      province: type == "province" ? search : "",
      postCode: type == "postCode" ? search : "",
    };

    this.getAllLocationService
      .exec(body)
      .then((res: any) => {
        this.isLoading[mode + "." + type] = false;
        this.results[mode + "." + type] = res.map((repo: any) => {
          let subDistrict: any = repo.subDistrict;
          let district: any = repo.district;
          let province: any = repo.province;
          let postCode: any = repo.postCode;
          let value: any = "";
          if (type == "subDistrict") {
            subDistrict = `<b>${subDistrict}</b>`;
            value = repo.subDistrict;
          } else if (type == "district") {
            district = `<b>${district}</b>`;
            value = repo.district;
          } else if (type == "province") {
            province = `<b>${province}</b>`;
            value = repo.province;
          } else if (type == "postCode") {
            postCode = `<b>${postCode}</b>`;
            value = repo.postCode;
          }
          let markup: any = [subDistrict, district, province, postCode].join(
            " >> "
          );
          return {
            text: repo[type],
            markup: markup,
            value: value,
            data: repo,
          };
        });
      })
      .catch((err) => {
        this.isLoading[mode + "." + type] = false;
        this.results = [];
      });
  }

  onSelect2(item: any, type: string, mode: string = "current") {
    if (item.data) {
      this.subDistrict = item.data.subDistrict;
      this.district = item.data.district;
      this.province2 = item.data.province;
      this.model.address[mode].subDistrict = item.data.subDistrict;
      this.model.address[mode].subDistrictText = item.data.subDistrict;
      this.model.address[mode].district = item.data.district;
      this.model.address[mode].districtText = item.data.district;
      this.model.address[mode].province = item.data.province;
      this.model.address[mode].provinceText = item.data.province;
      this.model.address[mode].postCode = item.data.postCode;
    } else {
      let arr = [
        "subDistrict",
        "subDistrictText",
        "district",
        "districtText",
        "province",
        "provinceText",
        "postCode",
        "zipCode",
      ];
      arr.map((val) => {
        if (val != type + "Text") {
          this.model.address[mode][val] = null;
        }
      });
    }
  }

  onClearSelect() {
    this.subDistrict = null;
    this.district = null;
    this.province2 = null;

    this.model.address.current.subDistrict = null;
    this.model.address.current.subDistrictText = null;
    this.model.address.current.district = null;
    this.model.address.current.districtText = null;
    this.model.address.current.province = null;
    this.model.address.current.provinceText = null;
    this.model.address.current.postCode = null;
    this.model.address.current.zipCode = null;
  }

  onFocused(e) {
    // do something when input is focused
  }

  onEditAddr() {
    this.editAddr.set(true);
    this.addrValue1 = "";
    this.model.address.current.subDistrictText = "";
    this.model.address.current.districtText = "";
    this.model.address.current.provinceText = "";
    this.model.address.current.postCode = "";
  }

  onEditTel() {
    this.editTel.set(true);
    this.phoneValue = this.insuredetail_data.phoneNo;
  }

  onInputAddr1(e) {
    this.addrValue1 = e.target.value;
  }

  onInputAddr2(e) {
    this.addrValue2 = e.target.value;
  }

  onInputAddr3(e) {
    for (let i = 0; i < this.insuredetail_data.province.length; i++) {
      if (e.target.value == this.insuredetail_data.province[i].value) {
        this.addrValue3 = this.insuredetail_data.province[i].detail;
        break;
      }
    }
  }

  onInputAddr4(e) {
    this.addrValue4 = e.target.value;
  }

  onInputPhone(e) {
    this.phoneValue = e.target.value;
  }

  onSaveTel() {
    this.editTel.set(false);
    this.insuredetail_data.phoneNo = this.phoneValue;
  }

  onCancelEditTel() {
    this.editTel.set(false);
  }

  onCancelEditAddr() {
    this.editAddr.set(false);
  }

  onSaveAddr(f: NgForm) {
    // เขต
    const address = this.addrValue1;
    const subDistrict = this.model.address.current.subDistrictText;
    const district = this.model.address.current.districtText;
    const province = this.model.address.current.provinceText;
    const postCode = this.model.address.current.postCode;
    const isValidate = this.onValiadteAddress(f);
    if (isValidate) {
      this.insuredetail_data.address = `${address} ${subDistrict} ${district} ${province} ${postCode}`;
      this.editAddr.set(false);
      this.resetModelAddress();
    }
  }

  resetModelAddress() {
    this.model = {
      address: {
        current: {
          subDistrict: "",
          subDistrictText: "",
          district: "",
          districtText: "",
          province: "",
          provinceText: "",
          postCode: "",
          postCodeText: "",
        },
      },
    };
    this.addrValue1 = "";
  }

  onValiadteAddress(f: NgForm) {
    f.form.markAsTouched();
    if (f.form.valid) {
      return true;
    }
    return false;
  }

  async onSubmit() {
    try {
      const isCarChange = this.compareCarChange();
      this.loader.set(true);
      const funcName = `onSubmit`;
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} isCarChange compareCar:${isCarChange}`)

      if (isCarChange) {
        this.f09Status = 32;
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} f09 status:32`)

        let body = this.createBodyUpdateRenew();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} createBodyUpdateRenew 1st body:${JSON.stringify(this.getMaskingService.maskingDataObj(body))}`)
        const responseUpdateRenew = await this.updateRenewDetailService.exec(
          body,
          ""
        );
        // this.logger.debug('responseUpdateRenew 1st', responseUpdateRenew);
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseUpdateRenew 1st response:${JSON.stringify(responseUpdateRenew)}`)

        let body_update_letter = this.createBodyUpdateLetter();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start update letter body:${JSON.stringify(this.getMaskingService.maskingDataObj(body_update_letter))}`)
        const responseUpdateLetter =
          await this.updateRenewLetterInstallment.exec(body_update_letter, "");
        // this.logger.debug('responseUpdateLetter', responseUpdateLetter);
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseUpdateLetter:${JSON.stringify(responseUpdateLetter)}`)

        let body_get_payment_summary = this.createBodyGetPaymentSummary();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start get payment summary:${JSON.stringify(body_get_payment_summary)}`)
        const responseGetPaymentSummary =
          await this.getMotorPaymentSummary.exec(body_get_payment_summary);
        // this.logger.debug('respnse bet payment summary', responseGetPaymentSummary);
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseGetPaymentSummary:${JSON.stringify(this.getMaskingService.maskingDataObj(responseGetPaymentSummary))}`)

        const prepareTSS = await this.populatePrepareData(
          isCarChange,
          responseGetPaymentSummary,
          body.payment_method
        );
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} prepareTSS car change:${JSON.stringify(this.getMaskingService.maskingDataObj(prepareTSS))}`)

        await this.callTssService(prepareTSS, isCarChange);
      } else {
        this.f09Status = 42;
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} f09 status:42`)
        let body = this.createBodyUpdateRenew();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} createBodyUpdateRenew 1st body:${JSON.stringify(this.getMaskingService.maskingDataObj(body))}`)
        const responseUpdateRenew = await this.updateRenewDetailService.exec(
          body,
          ""
        );
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseUpdateRenew 1st:${JSON.stringify(responseUpdateRenew)}`)

        let body_update_letter = this.createBodyUpdateLetter();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start update letter body:${JSON.stringify(this.getMaskingService.maskingDataObj(body_update_letter))}`)
        const responseUpdateLetter =
          await this.updateRenewLetterInstallment.exec(body_update_letter, "");
        // this.logger.debug('responseUpdateLetter', responseUpdateLetter);
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseUpdateLetter:${JSON.stringify(responseUpdateLetter)}`)

        let body_get_payment_summary = this.createBodyGetPaymentSummary();
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start get payment summary body:${JSON.stringify(body_get_payment_summary)}`)

        const responseGetPaymentSummary =
          await this.getMotorPaymentSummary.exec(body_get_payment_summary);
        // this.logger.debug('respnse bet payment summary', responseGetPaymentSummary);
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start get payment summary body:${JSON.stringify(this.getMaskingService.maskingDataObj(responseGetPaymentSummary))}`)

        const prepareTSS = await this.populatePrepareData(
          isCarChange,
          responseGetPaymentSummary,
          body.payment_method
        );
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} prepareTSS car not change:${JSON.stringify(this.getMaskingService.maskingDataObj(prepareTSS))}`)
        await this.callTssService(prepareTSS, isCarChange);
      }
      let body = this.createBodyUpdateRenew();
      // this.logger.debug('createBodyUpdateRenew', body);
      let showlogcreateBodyUpdateRenew = {
        input_license_no: this.getMaskingService.maskingData(
          body.input_license_no
        ),
        input_province: body.input_province,
        input_motor_action_type: body.input_motor_action_type,
        input_accessorise: body.input_accessorise,
        input_history: body.input_history,
        input_address: this.getMaskingService.maskingData(body.input_address),
        input_mobile_no: this.getMaskingService.maskingData(
          body.input_mobile_no
        ),
        input_letter_selected: body.input_letter_selected,
        f09_status: body.f09_status,
        renewMotorUCID: body.renewMotorUCID,
        payment_method: body.payment_method,
      };
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} createBodyUpdateRenew body:${JSON.stringify(showlogcreateBodyUpdateRenew)}`)
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} f09 Status:${this.f09Status}`)
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} Update Renew Detail start`)

      const responseUpdateRenew = await this.updateRenewDetailService.exec(
        body,
        ""
      );
      this.loader.set(false);
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} responseUpdateRenew: ${JSON.stringify(responseUpdateRenew)}`)

      // this.logger.info('responseUpdateRenew', responseUpdateRenew);
      if (responseUpdateRenew["status"]) {
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} Update Renew Success`)
        if (isCarChange) {
          this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} pushCarCangeMessage start`)

          this.pushCarChangeMessage();
        } else {
          this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} flexSummaryTemplate start`)
          this.logger.info([
            "Motor-step",
            this.insuredetail_data.refNo2,
            "flexSummaryTemplate",
          ]);
          this.flexSummaryTemplate();
        }
      } else {
        this.logger.error([
          "Motor-step",
          this.insuredetail_data.refNo2,
          "error responseUpdateRenew",
          responseUpdateRenew,
        ]);
      }
    } catch (error) {
      this.loader.set(false);
      this.logger.error([
        "Motor-step",
        this.insuredetail_data.refNo2,
        "error 5/5",
        error.message,
      ]);
    }
  }

  compareCarChange() {
    // carUsage, claim, decoration
    const funcName = `compareCarChange`
    this.insuredetail_data.decoration[0] =
      this.insuredetail_data.decoration[0].trim();
    const isDecorationSame = this.objectsAreSame(
      this.insuredetail_data.decoration,
      this.insuredetail_data_temp.decoration
    );
    const isClaimSame = this.objectsAreSame(
      this.insuredetail_data.claim,
      this.insuredetail_data_temp.claim
    );
    // this.logger.debug('isdecorationSame', isDecorationSame);
    // this.logger.debug('isclaimSame', isClaimSame);
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} decoration temp:${this.insuredetail_data_temp.decoration}`)
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} decoration new:${this.insuredetail_data.decoration}`)
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} isdecorationSame:${isDecorationSame}`)
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} claim temp:${this.insuredetail_data_temp.claim}`)
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} claim new:${this.insuredetail_data.claim}`)
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} isclaimSame:${isClaimSame}`)

    if (
      parseInt(this.insuredetail_data.carUsage) !==
      parseInt(this.insuredetail_data_temp.carUsage)
    ) {
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} carUsage change:true`)
      return true;
    } else if (!isDecorationSame) {
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} !isDecorationSame return true`)
      return true;
    } else if (!isClaimSame) {
      this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} !isClaimSame return true`)
      return true;
    }
    return false;
  }

  objectsAreSame(x, y) {
    let objectsAreSame = true;
    const len = x.length >= y.length ? x.length : y.length;
    if (x.length !== y.length) {
      return false;
    }
    for (let index = 0; index < len; index++) {
      if (!this.objectsEqual(x[index], y[index])) {
        objectsAreSame = false;
        break;
      }
    }
    return objectsAreSame;
  }

  objectsEqual(o1, o2) {
    return (
      Object.keys(o1).length === Object.keys(o2).length &&
      Object.keys(o1).every((p) => o1[p] === o2[p])
    );
  }

  populatePrepareData = async (
    isCarChange: boolean,
    PaymentSummary,
    paymentMethod: string
  ) => {
    const {
      car_accessories_old,
      car_accessories,
      claim_history_old,
      claim_history,
    } = this.populateArrayClaimsAndAcc();
    let item_type_old = this.insuredetail_data_temp.motorAction.filter(
      (list) => list.value == parseInt(this.insuredetail_data_temp.carUsage)
    );
    let motor_action_type_old = `${this.insuredetail_data_temp.item2936_16211}${
      parseInt(item_type_old[0].key) > 9
        ? parseInt(item_type_old[0].key)
        : `0${parseInt(item_type_old[0].key)}`
    } ${item_type_old[0].detail}`;
    let item_type_new = this.insuredetail_data_temp.motorAction.filter(
      (list) => list.value == parseInt(this.insuredetail_data.carUsage)
    );
    let motor_action_type = `${this.insuredetail_data.item2936_16211}${
      parseInt(item_type_new[0].key) > 9
        ? parseInt(item_type_new[0].key)
        : `0${parseInt(item_type_new[0].key)}`
    } ${item_type_new[0].detail}`;
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 lead_date",
      this.insuredetail_data.leadDate,
    ]);
    // let lead_date_data = new Date(this.insuredetail_data.leadDate);
    let lead_date_str = "";

    let convet_time_result: any = await this.convertTimestamp.exec({
      input_date: this.insuredetail_data.leadDate,
    });
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 lead_date result",
      convet_time_result,
    ]);
    if (convet_time_result.response_code === "40000") {
      lead_date_str = convet_time_result.response_data;
    }

    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 lead_date str",
      lead_date_str,
    ]);
    const prepareData = {
      app_code: this.insuredetail_data.appCode,
      account_no: this.insuredetail_data.accountNo,
      lead_date: lead_date_str,
      client_no: this.insuredetail_data.clientNo,
      classify_insure: "1",
      f09_update_inform: isCarChange ? "30" : "40",
      license_no_old: this.insuredetail_data_temp.carNo,
      license_no: this.insuredetail_data.carNo,
      register_province_old: parseInt(this.insuredetail_data_temp.carProvince),
      register_province: parseInt(this.insuredetail_data.carProvince),
      motor_action_type_old: motor_action_type_old,
      motor_action_type: motor_action_type,
      car_accessories_old: car_accessories_old,
      car_accessories: car_accessories,
      claim_history_old: claim_history_old,
      claim_history: claim_history,
      address_old: this.insuredetail_data_temp.address,
      address: this.insuredetail_data.address,
      mobile_no_old: this.insuredetail_data_temp.phoneNo,
      mobile_no: this.insuredetail_data.phoneNo,
      agent1: this.insuredetail_data.agent1,
      agent2: this.insuredetail_data.agent2,
      payment_summary: PaymentSummary.data ? PaymentSummary.data : "",
      payment_method: paymentMethod,
    };

    let f09_body = {
      app_code: prepareData.app_code,
      account_no: prepareData.account_no,
      lead_date: prepareData.lead_date,
      client_no: prepareData.client_no,
      f09_update_inform: prepareData.f09_update_inform,
      car_accessories: prepareData.car_accessories,
      car_accessories_old: prepareData.car_accessories_old,
      claim_history: prepareData.claim_history,
      claim_history_old: prepareData.claim_history_old,
      // payment_summary: prepareData.payment_summary,
      payment_method: prepareData.payment_method,
    };
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 Object",
      f09_body,
    ]);

    //license_no
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 license_no is not null",
      this.insuredetail_data.carNo == null || this.insuredetail_data.carNo == ""
        ? false
        : true,
      "is the same",
      this.insuredetail_data.carNo == this.insuredetail_data_temp.carNo
        ? true
        : false,
    ]);

    //register_province
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 register_province is not null",
      this.insuredetail_data.carProvince == null ||
      this.insuredetail_data.carProvince == ""
        ? false
        : true,
      "is the same",
      this.insuredetail_data.carProvince ==
      this.insuredetail_data_temp.carProvince
        ? true
        : false,
    ]);

    //motor_action_type
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 motor_action_type is not null",
      motor_action_type == null || motor_action_type == "" ? false : true,
      "is the same",
      motor_action_type == motor_action_type_old ? true : false,
    ]);

    //mobile_no
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 mobile_no is not null",
      this.insuredetail_data.phoneNo == null ||
      this.insuredetail_data.phoneNo == ""
        ? false
        : true,
      "is the same",
      this.insuredetail_data.phoneNo == this.insuredetail_data_temp.phoneNo
        ? true
        : false,
    ]);

    //address
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 address is not null",
      this.insuredetail_data.address == null ||
      this.insuredetail_data.address == ""
        ? false
        : true,
      "is the same",
      this.insuredetail_data.address == this.insuredetail_data_temp.address
        ? true
        : false,
    ]);

    //agent1
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 agent1 is not null",
      this.insuredetail_data.agent1 == null ||
      this.insuredetail_data.agent1 == ""
        ? false
        : true,
    ]);

    //agent2
    this.logger.info([
      "Motor-step",
      this.insuredetail_data.refNo2,
      "F09 agent1 is not null",
      this.insuredetail_data.agent2 == null ||
      this.insuredetail_data.agent2 == ""
        ? false
        : true,
    ]);

    return prepareData;
  };

  populateArrayClaimsAndAcc() {
    const car_accessories_old = [];
    if (this.insuredetail_data_temp.decoration.length) {
      this.insuredetail_data_temp.decoration.map((decoration) => {
        car_accessories_old.push(decoration);
      });
    }

    const car_accessories = [];
    if (this.insuredetail_data.decoration.length) {
      this.insuredetail_data.decoration.map((decoration) => {
        car_accessories.push(decoration.trim());
      });
    }

    const claim_history_old = [];
    if (this.insuredetail_data_temp.claim.length) {
      this.insuredetail_data_temp.claim.map((claim) => {
        claim_history_old.push(`${claim.detail}, ${claim.value}`);
      });
    }

    const claim_history = [];
    if (this.insuredetail_data.claim.length) {
      this.insuredetail_data.claim.map((claim) => {
        claim_history.push(`${claim.detail}, ${claim.value}`);
      });
    }
    return {
      car_accessories_old,
      car_accessories,
      claim_history_old,
      claim_history,
    };
  }

  callTssService(bodyTss, isCarChange: boolean): Promise<any> {
    this.f09Status = isCarChange ? 31 : 41;
    return this.callTss
      .exec(bodyTss)
      .then((res: any) => {
        this.logger.debug("callTssService res", res);
        if (res.response_code === "40000") {
          this.f09Status = isCarChange ? 30 : 40;
          return { status: true, data: res };
        } else {
          return { status: false, data: res };
        }
      })
      .catch((e) => {
        return { status: false, data: e };
      });
  }

  public calInstTerm(term: number, dataInst: any) {
    let instArr = [];

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1;
    var day = dateObj.getDate();
    var year = dateObj.getUTCFullYear();

    for (let j = 0; j < term; j++) {
      instArr.push(dataInst[j]);
    }

    for (let i = 0; i < term; i++) {
      let dateInst = new Date(dataInst[i].date);
      var month1 = dateInst.getUTCMonth() + 1;
      var day1 = dateInst.getDate();
      var year1 = dateInst.getUTCFullYear();
      instArr[i].date =
        day1.toString() + "/" + month1.toString() + "/" + year1.toString();
    }

    if (year1 == year) {
      if (month1 == month) {
        if (day1 >= day) {
          this.logger.debug(instArr);
        }
      } else if (month - month1 >= 1) {
        let c = month - month1;
        this.logger.debug(c);
        for (let j = 0; j < c; j++) {
          instArr.splice(j, 1);
        }
        for (let i = 0; i < c; i++) {
          instArr[0].amount = instArr[0].amount + dataInst[i].amount;
          instArr[0].date = dataInst[i - 1].date;
        }
        this.logger.debug(instArr);
      }
    }

    return instArr;
  }

  // send message,flex to line
  pushCarChangeMessage() {
    const funcName = `pushCarChangeMessage`
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} start`)

    let templateRef;
    templateRef = this.isCompulsory() ? "Renew-002-MOTOR-COMP" :"Renew-002-MOTOR";

    // this.line_id = 'Ue5f62ac228cc94c880193fe54644213b'
    // this.rm_channelId = '279'
    const populateLine = {
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channelId,
      templateRef: templateRef,
      templateParameter: {
        message: "987654321",
      },
      message: [],
    };
    this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} call sendLineMessageService body:${JSON.stringify(populateLine)}`)

    this.sendLineMessageService
      .exec(populateLine)
      .then(async (res) => {
        this.logger.info(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} call sendLineMessageService response:${JSON.stringify(res)}`)
        this.logger.debug("sendLineMessageService", res);
        if (res["status"] === true) {
          liff.closeWindow();
          this.logger.debug("success");
        } else {
          liff.closeWindow();
          this.logger.debug("fail");
        }
      })
      .catch((error) => {
        this.logger.error(`${this.logger_text} ${funcName} ${this.insuredetail_data.refNo2} error sendLineMessageService:${error?.message}`)
        liff.closeWindow();
      });
  }

  async flexSummaryTemplate() {
    this.logger.info("flexSummaryTemplate");
    // let product_type;
    // if (this.insuredetail_data.product_type.toLowerCase() == "ford") {
    //   product_type = "FORD";
    // }
    // else if (this.insuredetail_data.product_type.toLowerCase() == "mazda") {
    //   product_type = "MAZDA";
    // }
    // else if (this.insuredetail_data.product_type.toLowerCase() == "nissan") {
    //   product_type = "NISSAN";
    // }
    // else if (this.insuredetail_data.product_type.toLowerCase() == "insure") {
    //   product_type = "INSURE-MOTOR";
    // }

    let totalamount = this.total_amount();

    let image_header = environment.images_url + this.style.Header;
    let refNo2 = this.insuredetail_data.refNo2;
    let resultmasking = await this.getMaskingService.exec({
      insureNo: this.insuredetail_data.refNo2,
    });
    if (resultmasking["response_code"] == "40000" && resultmasking["data"]) {
      refNo2 = resultmasking["data"].masking_data[0].mask_value[0];
    }
    let url_credit = `https://liff.line.me/${this.liff_id}?dataucid=${this.dataucid}&letterucid=${this.letterucid}&page=payment-summary&liffId=${this.liff_id}&product_type=${this.product_type}&subchannel=${this.subChannel}`;
    let url_qrcode = `https://liff.line.me/${this.liff_id}?dataucid=${this.dataucid}&letterucid=${this.letterucid}&page=qr-barcode&liffId=${this.liff_id}&product_type=${this.product_type}&subchannel=${this.subChannel}`;
    // let url_payment_detail = `https://liff.line.me/${this.liff_id}?dataucid=${this.dataucid}&letterucid=${this.letterucid}&page=payment-detail&liffId=${this.liff_id}`
    this.logger.info("url_credit: ", url_credit);
    this.logger.info("url_qrcode: ", url_qrcode);

    let template_main = `{"type":"flex","altText":"ข้อมูลชำระเงิน","contents": {"type": "carousel","contents": [{"type": "bubble","size": "mega","direction": "ltr",`;

    //header
    template_main += `"header":{"type":"box","layout":"vertical","contents":[{"type":"box","layout":"vertical","flex":0,"contents":[{"type":"image","url":"${image_header}","flex":0,"margin":"none","align":"center","gravity":"top","size":"full","aspectRatio":"10:1","backgroundColor":"#FFFFFF","aspectMode":"fit"},{"type":"text","text":"สรุปรายการที่ท่านเลือก","position":"absolute","style":"normal","size":"15px","offsetStart":"15px","color":"#FFFFFF","offsetTop":"8px"}]}],"paddingAll":"0px"},`;

    //body
    template_main += `"body":{"type":"box","layout":"vertical","margin":"none","contents":[`;

    //body - head
    template_main += `{"type":"box","layout":"vertical","contents":[{"type":"text","text":"หมายเลขอ้างอิง ${refNo2}","size":"xxs","align":"start","color":"#c6c6c6","offsetTop":"5px"},{"type":"text","text":"ผลิตภัณฑ์ที่ต่ออายุ","size":"md","align":"start","weight":"bold","color":"#1c69b1","offsetTop":"10px"}], "paddingBottom":"15px"},`;

    //body detail-head
    template_main += `{"type":"box","layout":"horizontal","contents":[{"type":"image","url":"${
      environment.images_url
    }${
      this.insuredetail_data.logoOfferInsureBrand
    }","flex":1,"align":"start","gravity":"center","size":"xs","aspectRatio":"1:1","backgroundColor":"#ffffff"},{"type":"box","layout":"vertical","flex":3,"spacing":"none","margin":"sm","contents":[{"type":"text","text":"${
      this.insuredetail_data.offerInsureType
    }","size":"xxs","align":"start","color":"#c6c6c6","offsetTop":"5px"},{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"${
      this.insuredetail_data.nameOfferInsureBrand
    }","wrap": true,"size":"xs","align":"start"},{"type":"text","text":"${this.numberWithCommas(
      this.insuredetail_data.offerInsureAmount
    )} บาท","weight":"bold","size":"xs","align":"end","color":"#293845"}],"paddingTop":"10px"},{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"ครบกำหนด ${this.convertDateThai(
      this.insuredetail_data.lastClaimDate
    )}","size":"xxs","align":"start","weight":"bold","color":"#FF0000"}]}],"paddingStart":"5px"}]}`;

    this.insuredetail_data.additionalProduct.map((list) => {
      if (list.flag == "Y") {
        template_main += `,{"type":"box","layout":"horizontal","contents":[{"type":"image","url":"${this.image_url(
          list
        )}","flex":1,"align":"start","gravity":"center","size":"xs","aspectRatio":"1:1","backgroundColor":"#ffffff"},{"type":"box","layout":"vertical","flex":3,"spacing":"none","margin":"sm","contents":[{"type":"box","layout":"vertical","contents":[{"type":"separator","margin":"sm","color":"#DDDDDD"}],"paddingTop":"5px","paddingEnd":"0px","paddingBottom":"5px"},{"type":"text","text":"ผลิตภัณฑ์คุ้มครองเพิ่มเติม","size":"xxs","align":"start","weight":"bold","color":"#1c69b1","offsetTop":"5px"},{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"${
          list.product_name
        }","wrap": true,"size":"xs","align":"start"},{"type":"text","text":"${this.numberWithCommas(
          list.value
        )} บาท","weight":"bold","size":"xs","align":"end","color":"#293845"}],"paddingTop":"10px"}],"paddingStart":"5px"}]}`;
      }
    });

    //total amount
    template_main += `,{"type":"box","layout":"horizontal","contents":[{"type":"box","layout":"vertical","flex":2,"spacing":"none","margin":"sm","contents":[{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"ค่าเบี้ยประกันภัยทั้งหมด","size":"xxs","align":"start"},{"type":"text","text":"${this.numberWithCommas(
      totalamount
    )} บาท","weight":"bold","size":"xs","align":"end","color":"#293845"}],"paddingTop":"10px"}],"paddingStart":"0px"}]}`;

    //if installment show 1st round
    if (this.checkBokInstallment()) {
      template_main += `,{"type":"box","layout":"horizontal","contents":[{"type":"box","layout":"vertical","flex":2,"spacing":"none","margin":"sm","contents":[{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"ค่าเบี้ยประกันภัยงวดแรก","size":"xxs","align":"start"},{"type":"text","text":"${this.numberWithCommas(
        this.installmentData()[0].value
      )} บาท","weight":"bold","size":"xs","align":"end","color":"#293845"}],"paddingTop":"5px"}],"paddingStart":"0px"}]}`;
    }

    template_main += `,{"type":"box","layout":"vertical","contents":[{"type":"separator","margin":"sm","color":"#DDDDDD"}],"paddingTop":"5px","paddingEnd":"0px","paddingBottom":"5px"}`;
    //Payment Channel
    template_main += `,{"type":"box","layout":"horizontal","contents":[{"type":"box","layout":"vertical","flex":1,"spacing":"none","margin":"sm","contents":[{"type":"box","layout":"horizontal","contents":[{"type":"text","text":"ช่องทางการชำระเงิน","size":"xs","align":"center","weight":"bold"}],"paddingTop":"10px"}],"paddingStart":"5px"}],"paddingBottom": "10px"}`;
    template_main += `,{"type":"box","layout":"horizontal","contents":[{"type":"button","action":{"type":"uri","label":"เครดิต/เดบิต","uri":"${url_credit}&payment_method=total&amount=${
      this.checkBoxFullPay()
        ? totalamount.toFixed(2)
        : this.installmentData()[0].value.toFixed(2)
    }"},"style":"primary","color":"${
      this.style.Button
    }"}]},{"type":"box","layout":"horizontal","contents":[{"type":"button","action":{"type":"uri","label":"QRCode/Barcode","uri":"${url_qrcode}&amount=${
      this.checkBoxFullPay()
        ? totalamount.toFixed(2)
        : this.installmentData()[0].value.toFixed(2)
    }"},"style":"primary","color":"${this.style.Button}"}],"offsetTop":"5px"}`;

    let final_template = template_main + "]}}]}}";

    this.logger.debug(final_template);
    const populateLine = {
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channelId,
      message: [
        {
          type: 8,
          payload: {
            payloadDetail: JSON.parse(final_template),
          },
        },
      ],
    };

    this.logger.debug(populateLine);
    this.sendLineMessageService
      .exec(populateLine)
      .then(async (res) => {
        this.logger.info("sendLineMessageService");
        this.logger.debug("sendLineMessageService", res);
        if (res["status"] === true) {
          liff.closeWindow();
          this.logger.debug("success");
        } else {
          liff.closeWindow();
          this.logger.debug("fail");
        }
      })
      .catch((error) => {
        this.logger.error("error sendLineMessageService", error);
        this.modalService
                                      .open(
                                        LineModalTemplateComponent,
                                        this.lineModalService.setModalConfig(
                                          "alert",
                                          "ไม่สามารถทำรายการได้",
                                          [
                                            "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                          ]
                                        )
                                      )
                                      .onResult().subscribe({
                                        next: (result2) => {
                                          this.logger.info(`${this.logger_text} sendLineMessage popup success`);
                                        },
                                        error: (err2) => {
                                          this.logger.info(`${this.logger_text} sendLineMessage popup message:${err2}`);
                                        },
                                        complete: () => {
                                          this.logger.info(`${this.logger_text} sendLineMessage popup complete`);
                                        }
                                      })
      });
  }

  createBodyUpdateRenew() {
    const { car_accessories, claim_history } = this.populateArrayClaimsAndAcc();

    let payment_method: string = "";
    if (this.checkBoxFullPay()) {
      let date = new Date(this.insuredetail_data.lastClaimDate);
      let now_str = `${
        date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
      }/${
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`
      }/${date.getFullYear()}`;
      payment_method = `${this.total_amount()} ${now_str}`;
    } else {
      let index = 0;
      this.installmentData().map((list) => {
        if (index != 0) {
          payment_method += "|";
        }
        index = 1;
        let date = new Date(list.date);
        let now_str = `${
          date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
        }/${
          date.getMonth() + 1 > 9
            ? date.getMonth() + 1
            : `0${date.getMonth() + 1}`
        }/${date.getFullYear()}`;
        payment_method += `${list.value} ${now_str}`;
      });
    }

    let body = {
      input_license_no: this.insuredetail_data.carNo, //text
      input_province: parseInt(this.insuredetail_data.carProvince), //int
      input_motor_action_type: parseInt(this.insuredetail_data.carUsage), //int
      input_accessorise: car_accessories, //array ["text int", "text int"]
      input_history: claim_history, //array ["text, date", "text, date"] data format = 'dd/mm/yyyy'
      input_address: this.insuredetail_data.address, //text
      input_mobile_no: this.insuredetail_data.phoneNo, //text
      input_letter_selected: this.insuredetail_data.checkf09_3, //int
      f09_status: this.f09Status, //int
      renewMotorUCID: this.dataucid, //text
      payment_method: payment_method,
    };
    return body;
  }

  onSaveUpdateData() {
    /* data prep*/
    /*call function) */
    // let body = this.createBodyUpdateRenew()
    // this.updateRenewDetailService.exec(body, '')
  }

  calculateTotalPrice() {
    let amount = parseFloat(this.insuredetail_data.offerInsureAmount);
    this.insuredetail_data.additionalProduct.map((list) => {
      if (list.flag == "Y") {
        this.logger.debug(amount, parseFloat(list.value));
        amount = amount + parseFloat(list.value);
        this.logger.debug(amount);
      }
    });
    this.total_amount.set(parseFloat(amount.toFixed(2)));
  }

  addCheckAdditionalOptionToArray() {
    this.insuredetail_data.additionalProduct.map((list) => {
      if (list.flag == "Y") {
        this.additional_option.update(x=> [...x, true]);
      } else {
        this.additional_option.update(x=> [...x, false]);
      }
    });
  }

  clickAdditionalOption(index: number) {
    if (this.insuredetail_data.additionalProduct[index].flag == "Y") {
      this.insuredetail_data.additionalProduct[index].flag = "N";
      this.additional_option.update(x=> {
        const next = [...x];
        next[index] = false
        return next;
      })
    } else {
      this.insuredetail_data.additionalProduct[index].flag = "Y";
      this.additional_option.update(x=> {
        const next = [...x];
        next[index] = true;
        return next
      });
    }
    this.setAdditional_check_all();
    this.calculateTotalPrice();
  }

  setAdditional_check_all() {
    let count = this.additional_option().filter((item) => item == false).length;
    if (count == 0) {
      this.additional_check_all.set(true);
    } else {
      this.additional_check_all.set(false);
    }
  }

  clickCheckAllAdditionalOption() {
    if (this.additional_check_all() == false) {
      let i = 0;
      this.insuredetail_data.additionalProduct =
        this.insuredetail_data.additionalProduct.map((list) => {
          this.additional_option.update(x=> {
            const next = [...x];
            next[i] = true;
            return next;
          });
          i = i + 1;
          list.flag = "Y";
          return list;
        });
      this.additional_check_all.set(true);
      this.calculateTotalPrice();
    } else {
      let i = 0;
      this.insuredetail_data.additionalProduct =
        this.insuredetail_data.additionalProduct.map((list) => {
          this.additional_option.update(x=> {
            const next = [...x];
            next[i] = false;
            return next;
          })
          i = i + 1;
          list.flag = "N";
          return list;
        });
      this.additional_check_all.set(false);
      this.calculateTotalPrice();
    }
  }

  onClickFullPay() {
    if (this.checkBoxFullPay()) {
      this.checkBoxFullPay.set(false);
      this.checkBokInstallment.set(true);
    } else {
      this.checkBoxFullPay.set(true);
      this.checkBokInstallment.set(false);
    }
  }

  onClickInstallment() {
    if (this.checkBokInstallment()) {
      this.checkBoxFullPay.set(true);
      this.checkBokInstallment.set(false);
    } else {
      this.checkBoxFullPay.set(false);
      this.checkBokInstallment.set(true);
    }
  }

  async onLoadInstallment() {
    let additional_text: string[] = [];
    this.insuredetail_data.additionalProduct.map((list) => {
      let text = `${list.key},${list.detail},${list.value},${list.com},${list.flag}`;
      additional_text.push(text);
    });
    this.logger.debug(additional_text);
    this.dataLoadInstallment = await this.calculateInstallment.exec({
      data_ucid: this.dataucid,
      letter_ucid: this.letterucid,
      additional_option: additional_text,
    });

    this.logger.debug(this.dataLoadInstallment);

    if (this.dataLoadInstallment.response_code == "40000") {
      this.installmentData.set(this.dataLoadInstallment.data);
      if (this.installmentData().length > 1 && !this.isCompulsory()) {
        this.installmentStatus.set(true);
      }
    }
  }

  convertDateThai(input_date) {
    let months: any = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    let date_result = new Date(input_date);
    return `${date_result.getDate()} ${months[date_result.getMonth()]} ${
      date_result.getFullYear() + 543
    }`;
  }

  createBodyUpdateLetter() {
    let additional_text: string[] = [];
    this.insuredetail_data.additionalProduct.map((list) => {
      let text = `${list.key},${list.detail},${list.value},${list.com},${list.flag}`;
      additional_text.push(text);
    });

    let body = {
      letter_ucid: this.letterucid,
      additional_option: additional_text,
      //date
      _15957: this.installmentData()[0] ? this.installmentData()[0].date : null,
      _15958: this.installmentData()[1] ? this.installmentData()[1].date : null,
      _15959: this.installmentData()[2] ? this.installmentData()[2].date : null,
      _15960: this.installmentData()[3] ? this.installmentData()[3].date : null,
      _15961: this.installmentData()[4] ? this.installmentData()[4].date : null,
      _15962: this.installmentData()[5] ? this.installmentData()[5].date : null,
      _15963: this.installmentData()[6] ? this.installmentData()[6].date : null,
      _15964: this.installmentData()[7] ? this.installmentData()[7].date : null,
      _15965: this.installmentData()[8] ? this.installmentData()[8].date : null,
      _15966: this.installmentData()[9] ? this.installmentData()[9].date : null,
      //value
      _1521: this.installmentData()[0] ? this.installmentData()[0].value : null,
      _14765: this.installmentData()[1] ? this.installmentData()[1].value : null,
      _14766: this.installmentData()[2] ? this.installmentData()[2].value : null,
      _15967: this.installmentData()[3] ? this.installmentData()[3].value : null,
      _15968: this.installmentData()[4] ? this.installmentData()[4].value : null,
      _15969: this.installmentData()[5] ? this.installmentData()[5].value : null,
      _15970: this.installmentData()[6] ? this.installmentData()[6].value : null,
      _15971: this.installmentData()[7] ? this.installmentData()[7].value : null,
      _15972: this.installmentData()[8] ? this.installmentData()[8].value : null,
      _15973: this.installmentData()[9] ? this.installmentData()[9].value : null,
    };
    return body;
  }

  image_url(item) {
    if (item.logo !== undefined) {
      return `${environment.images_url}${item.logo}`;
    } else {
      let img = null;
      try {
        img = this.otherProductImage[item.key];
        return `${environment.images_url}/contents/images/${img}`;
      } catch (e) {
        return `${environment.images_url}/contents/images/null`;
      }
    }
  }

  createBodyGetPaymentSummary() {
    return {
      dataucid: this.dataucid,
      letterucid: this.letterucid,
    };
  }

  handleError(error,funcName){
    if (error?.error?.message) {
          this.logger.error(
            `${this.logger_text} ${funcName} error:${error?.error?.message}`
          );
          if (error?.error?.message === "access_token is required") {
            this.logger.error(
              `${this.logger_text} ${funcName} redirect to line login`
            );
            liff.logout();
            liff.login({ redirectUri: window?.location?.href });
          } else {
            this.logger.error(
              `${this.logger_text} ${funcName} error:${error?.message}`
            );
            this.modalService
              .open(
                LineModalTemplateComponent,
                this.lineModalService.setModalConfig(
                  "alert",
                  "ไม่สามารถทำรายการได้",
                  ["ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้"]
                )
              )
              .onResult()
              .subscribe({
                next: (result2) => {
                  this.logger.info(
                    `${this.logger_text} ${funcName} popup success`
                  );
                },
                error: (err2) => {
                  this.logger.info(
                    `${this.logger_text} ${funcName} popup message:${err2}`
                  );
                },
                complete: () => {
                  this.logger.info(
                    `${this.logger_text} ${funcName} popup complete`
                  );
                },
              });
          }
        } else {
          this.logger.error(
            `${this.logger_text} ${funcName} error:${error?.message}`
          );
          this.modalService
            .open(
              LineModalTemplateComponent,
              this.lineModalService.setModalConfig(
                "alert",
                "ไม่สามารถทำรายการได้",
                ["ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้"]
              )
            )
            .onResult()
            .subscribe({
              next: (result2) => {
                this.logger.info(
                  `${this.logger_text} ${funcName} popup success`
                );
              },
              error: (err2) => {
                this.logger.info(
                  `${this.logger_text} ${funcName} popup message:${err2}`
                );
              },
              complete: () => {
                this.logger.info(
                  `${this.logger_text} ${funcName} popup complete`
                );
              },
            });
        }
  }
}
